var map = {
	"./level1/core": 13906,
	"./level1/core.js": 13906,
	"./level2": 53044,
	"./level2/": 53044,
	"./level2/core": 39021,
	"./level2/core.js": 39021,
	"./level2/html": 45219,
	"./level2/html.js": 45219,
	"./level2/index": 53044,
	"./level2/index.js": 53044,
	"./level2/style": 60965,
	"./level2/style.js": 60965,
	"./level3": 78811,
	"./level3/": 78811,
	"./level3/core": 14612,
	"./level3/core.js": 14612,
	"./level3/html": 21078,
	"./level3/html.js": 21078,
	"./level3/index": 78811,
	"./level3/index.js": 78811,
	"./level3/ls": 59350,
	"./level3/ls.js": 59350,
	"./level3/xpath": 81892,
	"./level3/xpath.js": 81892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2728;